module.exports = __webpack_public_path__ + "static/media/impactIcon3.ae9eca95.png";